import sales from './sales';
import inventory from './inventory';

const pos = {
  inventory: inventory,
  sales: sales,
};

export default pos;
